import {
  architecture,
  restaurant,
  tryon,
  cart,
  navigation,
  carrent,
  cradle,
  startupindia,
  sisf,
  jobit,
  tripguide,
} from "../assets";

const terms = {
  title: "Terms & Conditions",
  data: `Last updated on Nov 13th 2022
  The Website Owner, including subsidiaries and affiliates (“Website” or “Website Owner” or “we” or “us” or “our”) provides the information contained on the website or any of the pages comprising the website (“website”) to visitors (“visitors”) (cumulatively referred to as “you” or “your” hereinafter) subject to the terms and conditions set out in these website terms and conditions, the privacy policy and any other relevant terms and conditions, policies and notices which may be applicable to a specific section or module of the website. Welcome to our website. If you continue to browse and use this website you are agreeing to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern XYZ3DAI (OPC) PRIVATE LIMITED''s relationship with you in relation to this website. The term 'XYZ3DAI (OPC) PRIVATE LIMITED' or 'us' or 'we' refers to the owner of the website whose registered/operational office is FLAT NO 4/A KRISH PALACE B BLOCK, Latma Road Hatia, Singh Road, Ranchi JHARKHAND 834003. The term 'you' refers to the user or viewer of our website. The use of this website is subject to the following terms of use:
  
  The content of the pages of this website is for your general information and use only. It is subject to change without notice.
  Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
  Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through this website meet your specific requirements.
  This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
  All trademarks reproduced in this website which are not the property of, or licensed to, the operator are acknowledged on the website.
  Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.
  From time to time this website may also include links to other websites. These links are provided for your convenience to provide further information.
  You may not create a link to this website from another website or document without XYZ3DAI (OPC) PRIVATE LIMITED’s prior written consent.
  Your use of this website and any dispute arising out of such use of the website is subject to the laws of India or other regulatory authority.
  We as a merchant shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time`,
};

const privacypolicy = {
  title: "Privacy Policy",
  data: `Last updated on Nov 13th 2022

  This privacy policy sets out how XYZ3DAI (OPC) PRIVATE LIMITED uses and protects any information that you give XYZ3DAI (OPC) PRIVATE LIMITED when you use this website. XYZ3DAI (OPC) PRIVATE LIMITED is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, and then you can be assured that it will only be used in accordance with this privacy statement. XYZ3DAI (OPC) PRIVATE LIMITED may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you are happy with any changes.
  
  We may collect the following information:
  Name and job title
  Contact information including email address
  Demographic information such as postcode, preferences and interests
  In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 2 days of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.
  In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them
  In case of any Refunds approved by the XYZ3DAI (OPC) PRIVATE LIMITED, it’ll take 16-30 days for the refund to be processed to the end customer
  What we do with the information we gather
  We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:
  
  Internal record keeping.
  We may use the information to improve our products and services.
  We may periodically send promotional emails about new products, special offers or other information which we think you may find interesting using the email address which you have provided.
  From time to time, we may also use your information to contact you for market research purposes. We may contact you by email, phone, fax or mail. We may use the information to customise the website according to your interests
  We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure we have put in suitable measures.
  
  How we use cookies
  A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyses web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences. We use traffic log cookies to identify which pages are being used. This helps us analyses data about webpage traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system. Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us. You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.
  
  Controlling your personal information
  You may choose to restrict the collection or use of your personal information in the following ways:
  
  if you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by writing to or emailing us at support@cobotiks.com
  whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the information to be used by anybody for direct marketing purposes
  We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen. If you believe that any information we are holding on you is incorrect or incomplete, please write to or email us as soon as possible, at the above address. We will promptly correct any information found to be incorrect.`,
};

const accordionData = [
  {
    title: "How can a business get started with AR?",
    content: `A business can get started with AR by defining its goals and objectives, identifying the target audience, selecting the appropriate AR technology, developing AR content, testing and optimizing the AR experience, and measuring the ROI.`,
  },
  {
    title: "What hardware is required for AR?",
    content: `AR can be experienced on a variety of devices, including smartphones, tablets, smart glasses, and headsets. The hardware requirements depend on the specific AR application and its level of complexity.`,
  },
  {
    title: "What is the future of AR in business?",
    content:
      "AR is the future, as the technology continues to advance, and more businesses recognize its potential to enhance customer engagement, drive sales, and streamline operations. AR is expected to become increasingly accessible, affordable, and integrated into everyday business operations in the coming years.",
  },
  {
    title: "How can AR be used in Restaurants?",
    content:
      "AR can be used to improve customer engagement by providing interactive menus, enabling customers to customize their orders, and providing immersive dining experiences.",
  },
];

export const navLinks = [
  {
    id: "usecases",
    title: "Services",
  },
  {
    id: "contact",
    title: "Contact",
  },
];

const services = [
  {
    title: "Interior Design (Interior designers, D2C & B2C brands)",
    icon: cart,
    link: "",
    description:
      " Our AI-based design studio automates space planning, personalizes recommendations, and optimizes workflows, saving time and resources while revolutionizing project execution and client experience",
  },
  {
    title: "Architecture (Architects & Home builders)",
    icon: restaurant,
    link: "",
    description:
      "Revolutionizing design by streamlining early-stage planning, optimizing sketching and generating innovative solutions to enhance sustainability",
  },
  {
    title: "Construction (PMC and construction contractors)",
    icon: tryon,
    link: "",
    description:
      "Our Studio can facilitate collaboration among architects, engineers, and other stakeholders by providing a common platform for sharing and iterating on design ideas in real-time.",
  },
  {
    title: "Design (Event designers)",
    icon: architecture,
    link: "",
    description:
      "AI can suggest personalized design elements such as seating arrangements, lighting schemes, and entertainment options tailored to individual guests or groups.",
  },
];

const testimonials = [
  {
    testimonial:
      "I thought it was impossible to make a website as beautiful as our product, but Rick proved me wrong.",
    name: "Sara Lee",
    designation: "CFO",
    company: "Acme Co",
    image: "https://randomuser.me/api/portraits/women/4.jpg",
  },
  {
    testimonial:
      "I've never met a web developer who truly cares about their clients' success like Rick does.",
    name: "Chris Brown",
    designation: "COO",
    company: "DEF Corp",
    image: "https://randomuser.me/api/portraits/men/5.jpg",
  },
  {
    testimonial:
      "After Rick optimized our website, our traffic increased by 50%. We can't thank them enough!",
    name: "Lisa Wang",
    designation: "CTO",
    company: "456 Enterprises",
    image: "https://randomuser.me/api/portraits/women/6.jpg",
  },
];
const backed = [
  {
    name: "STARTUP INDIA",
    image: startupindia,
    description:
      "Startup India is a flagship initiative of the Government of India, intended to catalyse startup culture for innovation and entrepreneurship in India",
  },
  {
    name: "SISF",
    image: sisf,
    description:
      "Startup India Seed Fund Scheme (SISFS) provides financial assistance to startups for proof of concept, prototype development, product trials, market-entry, and commercialization. ",
  },
  {
    name: "CRADLE",
    image: cradle,
    description:
      "Cradle helps startups in achieving innovative, scalable and sustainable growth with the aim of positive, creative and constructive value addition to the community.",
  },
];

const blogs = [
  {
    name: "AR: Unveiling the Digital Frontier",
    description:
      "Step into a world where reality intertwines with the virtual, as we dive deep into the realm of Augmented Reality (AR).",
    tags: [
      {
        name: "AR",
        color: "blue-text-gradient",
      },
      {
        name: "augmented",
        color: "green-text-gradient",
      },
      {
        name: "reality",
        color: "pink-text-gradient",
      },
    ],
    image: carrent,
  },
  {
    name: "XR: Bridging the Gap between Real and Virtual Worlds",
    description:
      "Discover the fascinating ways in which XR is enhancing our daily lives, from overlaying useful information onto our surroundings to creating immersive experiences.",
    tags: [
      {
        name: "XR",
        color: "blue-text-gradient",
      },
      {
        name: "Extended Reality",
        color: "green-text-gradient",
      },
    ],
    image: jobit,
  },
  {
    name: "Future of XR: Exploring  Virtual Reality",
    description:
      "Through insightful discussions and real-life examples, we delve into the practical applications of AR across various sectors",
    tags: [
      {
        name: "VR",
        color: "blue-text-gradient",
      },
      {
        name: "Virtual Reality",
        color: "green-text-gradient",
      },
    ],
    image: tripguide,
    source_code_link: "https://github.com/",
  },
];

export {
  accordionData,
  terms,
  privacypolicy,
  backed,
  services,
  testimonials,
  blogs,
};
